<style>
.dynamic-form .v-text-field.v-text-field--enclosed .v-text-field__details {
    margin-bottom: 0px;
}
.dynamic-form .v-messages {
  min-height: 5px;
}
</style>

<template>
  <div class="dynamic-form" v-if="details">
    <v-layout row wrap v-if="details && typeof details.type != 'undefined' && details.type == 'table'">
      <v-flex pt-0 pb-0>
          <dynamic-form-table :details="details" :row="details.row" :chart="chart" :stepper="stepper" :detailIndex="detailIndex" />
      </v-flex>
    </v-layout>
    <div v-else>
    <v-layout row wrap v-for="(row, index) in details.rows" v-if="details.rows">
      <v-flex pt-0 pb-0>
          <dynamic-form :details="details" :row="row" :chart="chart" :stepper="stepper" :key="index" :detailIndex="detailIndex" />
      </v-flex>
      <v-flex class="text-xs-right" xs12 v-if="typeof row.multiple != 'undefined' && row.multiple"  pt-0 pb-0>
          <span class="text-xs-right caption" @click="appendRows(details.rows, index)">{{ row.multipleText }}</span>
      </v-flex>
  </v-layout>
</div>
</div>
</template>
<script>
import DynamicFormTable from '@/components/charts/form/dynamic-form/table.vue';
import DynamicForm from '@/components/charts/form/dynamic-form/chart.vue';
export default {
    data: function() {
        return {
            componentKey: 0
        };
    },
    props: ['chart', 'details', 'stepper', 'detailIndex'],
    components: {
      'dynamic-form-table': DynamicFormTable,
      'dynamic-form': DynamicForm
    },
    methods: {
      removeRow(rows, index) {
              rows.splice(index, 1);
     }
     ,
      appendRows(rows, index) {
              let row = this.nullifyElements(rows[index]);
              // console.log("element old", rows[index]);
              // console.log("element new", row);
              rows.splice(index, 0, row);
          },
          nullifyElements(row) {
              let r = JSON.parse(JSON.stringify(row));
              for (let i = 0; i < r.elements.length; i++) {
                  r.elements[i].model = null;
              }
              return r;
          }
    },
    mounted() {
      // console.log("stepper", this.stepper);
      // console.log("detailIndex", this.detailIndex);
      // console.log("details", this.details);
      // this.chart.domain.status =
    }
}

</script>
